export function getNumberOfLettersLabel(value: unknown, maxLength?: number) {
  if (!value) return '';

  const numberOfValueLetters = typeof value === 'string' ? value.length : String(value).length;
  const formattedNumberOfValueLetters = numberOfValueLetters.toLocaleString();

  if (!maxLength) return formattedNumberOfValueLetters;

  return `${formattedNumberOfValueLetters}/${maxLength.toLocaleString()}`;
}
